export default __webpack_public_path__ + "static/reviewer-image-7-122ece2a5819cbd6abdb8e5d4fcf5f94.png";